import { api } from '@/lib/apiClient';

/** FR-NAV-05: one master tile's record count and how many records wait for a decision. */
export interface MasterTileCount {
  key: string;
  count: number;
  attention: number;
  attentionText: string | null;
}

export const MASTERS_SUMMARY_KEY = 'masters-summary';

export const mastersApi = {
  summary: () => api.get<MasterTileCount[]>('/masters/summary'),
};
